export const specialtyRoutes = {
  'api.specialty.type.datatable': 'specialties',
};
